const styles = {
  '@media print': {
    displayPrint: 'block',
    marginX: 'auto',
    fontWeight: 600,
    textAlign: 'center',
  },
};

export default styles;
